import { Box, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import Carrito from "../Components/Carrito/Carrito";
import PeliculaSimple from "../Components/Entradas/Pelicula/PeliculaSimple";
import Headline from "../Components/HeadlineTimer/Headline";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useCurrentWindow from "../hooks/useCurrentWindow";
import PaymentContainer from "../Components/Payment-Methods/PaymentContainer";

function Payment() {
  const location = useLocation();
  const [isVertical, setIsVertical] = useState(false);
  const methodSelected = useSelector(
    (state) => state.DatosPayment.methodSelected
  );
  const titleHeading =
    methodSelected === "POINT"
      ? "Pago mediante Point"
      : methodSelected === "QR"
      ? "Pago mediante QR"
      : "Pago en efectivo";
  const windowSize = useCurrentWindow();

  useEffect(() => {
    if (windowSize.width < windowSize.height) setIsVertical(true);
    else setIsVertical(false);
  }, [windowSize]);

  return (
    <Box
      marginTop={1}
      sx={{
        maxWidth: "1024px",
        height: "auto",
        marginX: "auto",
        paddingX: { xs: "10px", md: "5px" },
      }}
    >
      <Grid container spacing="2rem">
        <Grid item xs={windowSize.width < windowSize.height ? 12 : 8}>
          <PeliculaSimple />
          <Headline title={titleHeading} />
          <PaymentContainer />
        </Grid>
        <Grid
          item
          xs={isVertical ? 12 : 4}
          height={isVertical ? "auto" : `${windowSize.height}px`}
        >
          <Carrito
            nextPage={`${location.search}`}
            isVertical={isVertical}
            disabledCancel={true}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Payment;
